export default __webpack_public_path__ + "static/media/03.76eea0e0.jpg";